import { env } from './env';

export type ToolId =
  | 'sales'
  | 'eds'
  | 'calls'
  | 'bi'
  | 'knowledge-base'
  | 'task-control'
  | 'time-report'
  | 'ai-files'
  | 'logistics';

export type ToolLink = {
  id: ToolId;
  label: string;
  href: string;
};

export const toolsLinks: ToolLink[] = [
  { id: 'sales', label: 'Продажи', href: env.toolsCallsUrl },
  { id: 'eds', label: 'ЭЦП', href: env.toolsEdsUrl },
  { id: 'calls', label: 'Звонки', href: env.toolsSalesUrl },
  { id: 'bi', label: 'BI', href: env.toolsBiUrl },
  {
    id: 'knowledge-base',
    label: 'База знаний',
    href: env.toolsKnowledgeBaseUrl,
  },
  {
    id: 'task-control',
    label: 'Контроль задач',
    href: env.toolsTaskControlUrl,
  },
  {
    id: 'time-report',
    label: 'Отчет по трудозатратам',
    href: env.toolsTimeReportUrl,
  },
  { id: 'ai-files', label: 'AI Files', href: env.toolsAiFilesUrl },
  { id: 'logistics', label: 'Логистика', href: env.toolsLogisticsUrl },
];

export function getToolLink(toolId: string | undefined) {
  return toolsLinks.find((tool) => tool.id === toolId);
}
